import { useRouter } from "@uirouter/react";
import { useCallback } from "react";
import { QueryClient } from "react-query";
import { PageNotFoundRoutes } from "../pages/error/routes";
export const queryClient = new QueryClient();

export function useDefaultQueryOptions() {
  const router = useRouter();

  return {
    retry: useCallback(
      (failureCount, error) =>
        failureCount < 3 && (error as any)?.status !== 404,
      []
    ),
    onError: useCallback(
      (err) => {
        if ((err as any)?.status === 404) {
          router.stateService.go(PageNotFoundRoutes.names.pageNotFound, {
            location: false,
          });
        }
      },
      [router]
    ),
  };
}
